import React from "react";
import { AnimatePresence, motion } from "framer-motion";
import noConnection from "../assets/images/noconnection.svg";

const NetworkStatusPopup = ({ open, onClose }) => {
  return (
    <div
      className={`modal fade ${open ? "show" : ""} d-block`}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1050,
        backdropFilter: "blur(2px)",
        WebkitBackdropFilter: "blur(8px)",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        pointerEvents: open ? "auto" : "none",
        visibility: open ? "visible" : "hidden",
      }}
    >
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            transition={{ type: "spring", stiffness: 500, damping: 30 }}
            className="modal-dialog modal-dialog-centered"
          >
            <div
              className="modal-content border-0"
              style={{
                background: "linear-gradient(135deg, #1a6bff 0%, #0d47a1 100%)",
                boxShadow: "0 10px 30px rgba(26, 107, 255, 0.3)",
                borderRadius: "20px",
                position: "relative",
                zIndex: 1051,
              }}
            >
              <div className="modal-body p-5 text-center d-flex flex-column align-items-center">
                <div
                  className="mb-4"
                  style={{ width: "200px", height: "200px" }}
                >
                  <img
                    src={noConnection}
                    alt="No Connection"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                    }}
                  />
                </div>
                <h3 className="text-white mb-3">No Internet Connection</h3>
                <p className="text-white-50 mb-4">
                  Your device is not connected to the internet. Please check
                  your network connection and try again.
                </p>
                <div className="d-flex justify-content-center gap-3">
                  <button
                    className="btn btn-light px-4 py-2 rounded-pill"
                    style={{
                      background: "rgba(255,255,255,0.9)",
                      border: "none",
                      fontWeight: "600",
                      minWidth: "120px",
                    }}
                    onClick={onClose}
                  >
                    Retry
                  </button>
                </div>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default NetworkStatusPopup;
